import { BrSdk } from '@bloomreach/vue-sdk'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(BrSdk)
})
